module.exports.monthlyPlans = [
  {
    name: "FREE",
    price: "$0",
    features: [
      "10 Credits",
      "Basic features",
      "Includes ads 📣",
      "Limited Free tools Access",
    ],
    cta: "Free",
    popular: false,
  },
  {
    name: "STARTER",
    price: "$2.99",
    features: [
      "100 Credits/mo",
      "Priority support",
      "Strictly No ads 🚫",
      "Basic analytics",
      "+15 Free tools",
    ],
    cta: "🚀 Get Started",
    popular: false,
  },
  {
    name: "GROWTH",
    price: "$5.99",
    features: [
      "200 Credits/mo",
      "All STARTER features",
      "Advanced analytics",
      "API access",
    ],
    cta: "🔥 Trending",
    popular: true,
  },
  {
    name: "PRO",
    price: "$9.99",
    features: [
      "400 Credits/mo",
      "All GROWTH features",
      "24/7 support",
    ],
    cta: "💼 Go Pro",
    popular: false,
  },
  {
    name: "BUSINESS",
    price: "$19.99",
    features: [
      "1000 Credits/mo",
      "Dedicated account manager",
      "Team management",
      "All PRO features",
    ],
    cta: "🏢 GO BIZ ",
    popular: false,
  },
];

module.exports.annualPlans = [
  {
    name: "FREE",
    price: "$0",
    features: ["10 Credits", "Basic features", "Includes ads 📣", "Limited Free Access",],
    cta: "Free",
    popular: false,
  },
  {
    name: "STARTER",
    price: "$1.25",
    comparePrice: "$2.99", // 2.99 * 12
    features: [
      "1.2k Credits/mo",
      "Priority support",
      "Strictly No ads 🚫",
      "Basic analytics",
      "+15 Free tools",
    ],
    cta: "🚀 Get Started",
    popular: false,
  },
  {
    name: "GROWTH",
    price: "$2.99",
    comparePrice: "$5.99", // 5.99 * 12
    features: [
      "2.4k Credits/mo",
      "All STARTER features",
      "Advanced analytics",
      "API access",
    ],
    cta: "🔥 Trending",
    popular: true,
  },
  {
    name: "PRO",
    price: "$4.99",
    comparePrice: "$9.99", // 9.99 * 12
    features: [
      "4.8k Credits/mo",
      "All GROWTH features",
      "24/7 support",
    ],
    cta: "💼 Go Pro",
    popular: false,
  },
  {
    name: "BUSINESS",
    price: "$9.99",
    comparePrice: "$19.99", // 19.99 * 12
    features: [
      "12k Credits/mo",
      "Dedicated account manager",
      "Team management",
      "All PRO features",
    ],
    cta: "🏢 GO BIZ",
    popular: false,
  },
];
